import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './editar-banner.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Tooltip,
  IconButton,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Wrap,
  TagCloseButton,
  Tag,
  WrapItem,
  TagLabel
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/banner';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { obterUsuario } from '../../../../api/usuario';
import { MdInfoOutline } from 'react-icons/md';
import { ImageDropzoneMax500mb } from '../../../../components/common/imageDropzoneMax500mb/imageDropzoneMax500mb';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { FaPlus } from 'react-icons/fa';
import { deletarSecretariaAssociada, listarSecretariasAtivas } from '../../../../api/secretarias';

const EditarBanner: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    urlBanner: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    ordemBanner: { value: any[]; error: boolean };
    categoriaId: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    urlBanner: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    ordemBanner: { value: [], error: false },
    categoriaId: { value: '', error: false },
    secretariaId: { value: [], error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [categorias, setCategorias] = useState<any[]>([]);
  const [paginas, setPaginas] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [secretariasRemovidas, setSecretariasRemovidas] = useState<number[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [temImagem, setTemImagem] = useState<boolean>(false)
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isAtivo, setIsAtivo] = useState<number>(1);
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');
  const [getCodSituacaoPubli, setgetCodSituacaoPubli] = useState<number>(1);
  const [motivosReprovacao, setMotivosReprovacao] = useState('');
  const [getObjPendencia, setgetObjPendencia] = useState<any>();

  const fetchBannerData = async () => {
    setIsLoading(true);
    try {
      const bannerData = await api.obterBanner(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        datDespublicar,
        dscCreditoImagem,
        dscDescricaoImagem,
        dscAltImagem,
        seqCategoria,
        conteudoSecretariaDTO,
        conteudoPaginaDTO,
        binPublicacao,
        urlBin,
        pendencia,
        numRegistro,
        dscCitacaoUsuario,
        codSituacaoPubli
      } = bannerData;

      if (bannerData.codSituacaoPubli) {
        setgetCodSituacaoPubli(bannerData.codSituacaoPubli)
      }

      if (pendencia && pendencia.dscObs) {
        setMotivosReprovacao(pendencia.dscObs);
      }

      if (bannerData.pendencia) {
        setgetObjPendencia(bannerData.pendencia)
      }

      let exigeAprovacaoValue = 0;
      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
      }
      const usuarioIdValue = pendencia?.seqExecutor;
  
      const paginas = conteudoPaginaDTO.map((item: any) => item.seqPagina);
      const ordens = conteudoPaginaDTO.map((item: any) => item.numOrdem);

      const selecionadas = (conteudoSecretariaDTO ?? []).map((i: any) => Number(i.codSecretaria));
  
      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        imagem: { value: binPublicacao || '', error: false },
        urlBanner: { value: urlBin || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: dscDescricaoImagem || '', error: false },
        altImagem: { value: dscAltImagem || '', error: false },
        ordemBanner: {
          value: conteudoPaginaDTO.map((item: any) => ({
            seqPagina: item.seqPagina,
            numOrdem: item.numOrdem,
          })),
          error: false,
        },
        usuarioId: { value: usuarioIdValue, error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        categoriaId: { value: seqCategoria.toString(), error: false },
        paginaId: { value: paginas, error: false },
        secretariaId: { value: selecionadas, error: false },
      });

      setSecretariaSelecionada(selecionadas);

      if(bannerData.numRegistro == 0) {
        setIsAtivo(0)
      }

      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));
  
      if (binPublicacao && binPublicacao.trim() !== "") {
        setTemImagem(true);
        
        setFormValues((prev) => ({
          ...prev,
          imagem: { value: binPublicacao, error: false },
        }));
  
        setImagePreview(atualizarPreview(binPublicacao));
        
        const delimiter = "%2F";
        const index = binPublicacao.lastIndexOf(delimiter);
        const finalFileName =
          index !== -1 ? binPublicacao.substring(index + delimiter.length) : binPublicacao;
        setNomeCdn(finalFileName);
      } else {
        setTemImagem(false);
      }

      setFormValues((prevValues) => ({
        ...prevValues,
      }));
  
    } catch (error) {
      console.error("Erro ao buscar dados do banner:", error);
    } finally {
      setIsLoading(false);
    }
  };  

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchBannerData();
    fetchCategorias();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const validarOrdemAoSair = async (seqPagina: number, numOrdem: string, inputRef: React.RefObject<HTMLInputElement>) => {
    try {
      const ordensExistentes = await api.validarOrdemDisponiveis(seqPagina);

      const numOrdensExistentes = ordensExistentes.map((ordem: any) => ordem.numOrdem);

      if (numOrdensExistentes.includes(parseInt(numOrdem))) {
        setFormValues((prevValues: any) => {
          const updatedOrdemValue = prevValues.ordemBanner.value.map((item: any) => {
            if (item.seqPagina === seqPagina) {
              return { ...item, numOrdem: '' };
            }
            return item;
          });
          return {
            ...prevValues,
            ordemBanner: { value: updatedOrdemValue },
          };
        });

        const recomendada = calcularOrdemRecomendada(ordensExistentes);

        Swal.fire({
          icon: 'warning',
          title: 'Ordem Indisponível',
          text: `A ordem fornecida não está disponível. É recomendado usar o número ${recomendada}`,
          confirmButtonText: 'Fechar',
          // willClose: () => {
          //   setOrdemRecomendada(recomendada);
          // },
        });
      }
    } catch (error) {
      console.error('Erro ao validar ordem:', error);
      setErrorMessage('Houve um erro ao validar a ordem. Tente novamente mais tarde.');

      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Houve um erro ao validar a ordem. Tente novamente mais tarde.',
        confirmButtonText: 'Fechar',
      });

      setIsErrorModalOpen(true);
    }
  };

  const calcularOrdemRecomendada = (ordensExistentes: any[]) => {
    const todosNumOrdem = ordensExistentes.map(item => item.numOrdem);
    let recomendada = 1;
    while (todosNumOrdem.includes(recomendada)) {
      recomendada++;
    }
    return recomendada;
  };
  
  const handleDeletePages = () => {
    removedPages.forEach((seqPagina) => {
      api.deletarRelacionamentoPagina(Number(id), seqPagina);
    });
  };

  const handleDeleteSecretarias = async () => {
    try {
      for (const codSecretaria of secretariasRemovidas) {
        await deletarSecretariaAssociada(codSecretaria, Number(id));
      }

      setSecretariasRemovidas([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario((prevTagUsuario) =>
        prevTagUsuario ? `${prevTagUsuario} ${inputValueTagUsuario.trim()}` : inputValueTagUsuario.trim()
      );
      setInputValueTagUsuario('');
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario((prevTagUsuario) => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter((tag) => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev => {
      const next = checked
        ? Array.from(new Set([...prev, codSecretaria]))
        : prev.filter(id => id !== codSecretaria);
      return next;
    });

    setSecretariasRemovidas(prev =>
      checked
        ? prev.filter(id => id !== codSecretaria)
        : Array.from(new Set([...prev, codSecretaria]))
    );

    setFormValues((prev: any) => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);

      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };  

  const handleImageSelected = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isImagem = selecionado.type.startsWith("image/");
      const isVideo = selecionado.type.startsWith("video/");
      const isAudio = selecionado.type.startsWith("audio/");

      setArquivo(selecionado);

      if (isImagem || isVideo || isAudio) {
        setArquivoSelecionado(selecionado);
        setArquivo(selecionado);
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          const novaUrl = atualizarPreview(reader.result);
          setImagePreview(novaUrl);
          setFormValues((prev) => ({
            ...prev,
            imagem: { value: novaUrl, error: false },
          }));
        }
      };
      reader.readAsDataURL(selecionado);
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      setImagePreview("");
      console.warn("Nenhum arquivo selecionado.");
    }
  };  

  const isFormValid = () => {
    const { titulo, data, creditoAutorImagem, ordemBanner, categoriaId, paginaId } = formValues;

    const isOrdemValida = ordemBanner?.value?.every((item: any) => item.numOrdem && item.numOrdem !== '0') || false;
    const isPaginaIdValido = Array.isArray(paginaId.value) && paginaId.value.length > 0;
    const isOrdemBannerValido = Array.isArray(ordemBanner.value) && ordemBanner.value.length > 0;

    const isValid = (
      titulo.value &&
      data.value &&
      imagePreview &&
      creditoAutorImagem.value &&
      ordemBanner.value &&
      categoriaId.value &&
      isPaginaIdValido &&
      isOrdemBannerValido &&
      isOrdemValida
    );

    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);
  
    await handleDeletePages();
    await handleDeleteSecretarias();
  
    const { urlBanner, creditoAutorImagem, descricaoImagem, altImagem, ordemBanner, dataFim, categoriaId, secretariaId, paginaId, usuarioId, data, imagem } = formValues;
  
    const uniquePaginaIds = Array.from(new Set(paginaId.value));
  
    const conteudoPaginaDTO = uniquePaginaIds.map((id: number) => {
      const ordem = ordemBanner.value.find((item: any) => item.seqPagina === id);
      return {
        seqPagina: id,
        numOrdem: ordem ? Number(ordem.numOrdem) : null,
        datFim: dataFim.value ? formValues.dataFim.value : null,
      };
    });

    const pendencia = usuarioId.value
      ? {
        codPendencia: 1,
        seqSolicitante: seqUsuario,
        seqExecutor: usuarioId.value,
      }
      : null;

      if(getCodSituacaoPubli == 6) {
        getObjPendencia['codPendencia'] = 1;
      }
  
      let codSituacao = 1;
  
      if (data.value) {
        const dataDaPublicacao = data.value;
        const diaDeHoje = new Date().toISOString().split("T")[0];
  
        if (getObjPendencia) {
          codSituacao = 5;
        } else if (dataDaPublicacao > diaDeHoje) {
          codSituacao = 1;
        } else if (dataDaPublicacao === diaDeHoje) {
          codSituacao = 2;
        }  
      } else {
        codSituacao = 2;
      }
  
    const params: PublicacaoParams = {
      numRegistro: isAtivo,
      codSituacaoPubli: codSituacao,
      codTipoPublicacao: 3,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: dataFim.value ? formValues.dataFim.value : null,
      seqUsuario: seqUsuario,
      binPublicacao: imagem.value || '',
      urlBin: urlBanner.value || null,
      dscCreditoImagem: creditoAutorImagem.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      dscAltImagem: altImagem.value || null,
      seqCategoria: Number(categoriaId.value) || null,
      dscCitacaoUsuario: tagUsuario,
      pendencia: getObjPendencia || null,
      numAprovacao: pendencia ? 1 : 0,
      conteudoPaginaDTO: paginaId.value.map((id: any) => {
        const ordem = ordemBanner.value.find((item: any) => item.seqPagina === Number(id));
        return {
          seqPagina: Number(id),
          numOrdem: ordem ? parseInt(ordem.numOrdem) : null,
        };
      }),
      dscResumo: null,
      dscTags: null,
      dscPublicacao: null,
      dscCreditoNoticia: null,
      numAprovado: 0,
      datInicioEvento: null,
      datFimEvento: null,
      contasRedeSocial: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };
  
    try {
      if (arquivoSelecionado && temImagem) {
        const formData = new FormData();
        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'banner';
        
        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.editarBannerNoCdn(formData);
        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
        
        params.binPublicacao = cdnUrl;
      }

      if (arquivoSelecionado && !temImagem) {
        const formData = new FormData();

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'banner';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'banner';
        
        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.inserirBannerNoCdn(formData);
        let cdnUrl = "";
        
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
        
        params.binPublicacao = cdnUrl;
      }

      await api.editarBanner(Number(id), params);
      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Banner editado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao editar banner:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar banner. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    }
  };

  const inativarPublicacao = async () => {     
    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 3;
    }

    Swal.fire({
      title: 'Tem certeza?',
      text: "Certeza que deseja inativar imediatamente a Publicação?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',    
      confirmButtonText: 'Sim, inativar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          pendencia: getObjPendencia || null,
          seqUsuario: seqUsuario,
          numRegistro: 0,
          codSituacaoPubli: 3
        };
  
        try {
          await api.editarBanner(Number(id), params);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Banner inativado com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        } catch (error) {
          console.error('Erro ao inativar banner:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao inativar banner. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        }
      }
    });
  };  

  const mostrarMotivoReprovacao = () => {
    const texto = motivosReprovacao || 'Motivos não informados.';
    const isTextoLongo = texto.length > 150;
  
    Swal.fire({
      title: 'Motivos da Reprovação',
      width: isTextoLongo ? '50%' : undefined,
      html: `<div style="max-height: 250px; overflow-y: auto;">
              <p>${texto}</p>
            </div>`,
      icon: 'warning',
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Entendi'
    });
  };  
  
  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Banner
      </Heading>
      {isAtivo == 0 && (
        <Flex justifyContent="end">
          <Alert status="error" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Inativada</AlertTitle>
              <AlertDescription display="block">
                Este banner foi permanentemente inativado e não poderá ser reativado.
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {getCodSituacaoPubli === 6 && (
        <Flex justifyContent="end">
          <Alert status="warning" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Reprovada</AlertTitle>
              <AlertDescription display="block">
                Após revisão, sua publicação não obteve aprovação.{' '}
                <Button variant="link" colorScheme="blue" onClick={mostrarMotivoReprovacao}>
                  Clique aqui para ver os motivos.
                </Button>
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Categoria do Banner</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.categoriaId.value}
                    onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título da Publicação</FormLabel>
                  <CustomInput
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">URL para tornar banner clicável</FormLabel>
                  <CustomInput
                    placeholder="Digite uma URL"
                    value={formValues.urlBanner.value}
                    onChange={(e) => handleFieldChange('urlBanner', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    id="banner-edit-publication-date"
                    type="date"
                    value={formValues.data.value}
                    onChange={(e) => handleFieldChange('data', e.target.value)}
                  />
                </FormControl>
              </div>
              <div className="col-md-3 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                  <CustomInput
                    id="banner-edit-unpublish-date"
                    type="date"
                    value={formValues.dataFim.value}
                    onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                  />
                </FormControl>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Imagem do Banner</FormLabel>
                  <ImageDropzoneMax500mb
                    base64={imagePreview}
                    onImageSelected={handleImageSelected}
                    uploadMessage="Arraste ou selecione uma imagem"
                    width={1200}
                    height={400}
                  />
                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                    onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                  />
                </FormControl>
              </div>
            </div>

            <div className="row">

              <div className="col-md-6 mb-4">
              <FormControl>
                  <FormLabel mb="8px">Tags</FormLabel>
                  <div style={{ display: 'flex' }}>
                    <CustomInput
                      value={inputValueTagUsuario}
                      onChange={handleInputChangeTagUsuario}
                      placeholder="Digite uma tag"
                      maxLength={100}
                    />
                    <Button onClick={handleAddTagUsuario} ml="2">
                      <FaPlus />
                    </Button>
                  </div>
                </FormControl>
                <div className="rolagem-hashtag mb-2">
                  <Wrap spacing="2px">
                    {tagUsuario?.trim() &&
                      tagUsuario.split(' ').map((tag, index) => (
                        <WrapItem key={index}>
                          <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                            <TagLabel>{tag}</TagLabel>
                            <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                          </Tag>
                        </WrapItem>
                      ))}
                  </Wrap>
                </div>
                <FormControl>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas o banner deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <FormLabel mb="8px">
                      Ordem de exibição <span style={{ color: 'red' }}>*</span>
                      <Tooltip label="Ordem a ser utilizada para exibir o banner nas páginas." aria-label="A informação da ordem de exibição">
                        <IconButton
                          className='icones'
                          variant='link'
                          icon={<MdInfoOutline />}
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                  </Flex>

                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina) => {
                          const inputRef = React.createRef<HTMLInputElement>();
                          return (
                            <Flex
                              key={pagina.seqPagina}
                              align="center"
                              justify="space-between"
                              direction={{ base: 'column', md: 'row' }}
                            >
                              <Checkbox
                                className="checkPaginasNoticia"
                                isChecked={formValues.paginaId.value.includes(pagina.seqPagina)}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;

                                  setFormValues((prevValues: any) => {
                                    const updatedPaginaIdValue = isChecked
                                      ? [...prevValues.paginaId.value, pagina.seqPagina]
                                      : prevValues.paginaId.value.filter((id: number) => {
                                        const shouldRemove = id === pagina.seqPagina;
                                        if (shouldRemove) {
                                          setRemovedPages((prevRemovedPages) => [
                                            ...prevRemovedPages,
                                            pagina.seqPagina,
                                          ]);
                                        }
                                        return !shouldRemove;
                                      });

                                    let updatedOrdemBanner = [...prevValues.ordemBanner.value];

                                    if (isChecked) {
                                      updatedOrdemBanner.push({ seqPagina: pagina.seqPagina, numOrdem: '' });
                                    } else {
                                      updatedOrdemBanner = updatedOrdemBanner.filter(
                                        (item: any) => item.seqPagina !== pagina.seqPagina
                                      );
                                    }

                                    return {
                                      ...prevValues,
                                      paginaId: { value: updatedPaginaIdValue },
                                      ordemBanner: { value: updatedOrdemBanner, error: prevValues.ordemBanner.error },
                                    };
                                  });

                                  if (isChecked) {
                                    setRemovedPages((prevRemovedPages) =>
                                      prevRemovedPages.filter((seqPagina) => seqPagina !== pagina.seqPagina)
                                    );
                                  }
                                }}
                              >
                                {pagina.nomPagina}
                              </Checkbox>

                              <div>
                                <CustomInput
                                  type="number"
                                  className="input-ordem-edit"
                                  isDisabled={!formValues.paginaId.value.includes(pagina.seqPagina)}
                                  value={(() => {
                                    const ordemItem = formValues.ordemBanner.value.find(
                                      (item: any) => item.seqPagina === pagina.seqPagina
                                    );
                                    return ordemItem ? ordemItem.numOrdem : '';
                                  })()}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    setFormValues((prevValues: any) => {
                                      const updatedOrdemValue = [...prevValues.ordemBanner.value];
                                      const existingOrderIndex = updatedOrdemValue.findIndex(
                                        (item: any) => item.seqPagina === pagina.seqPagina
                                      );

                                      if (existingOrderIndex > -1) {
                                        updatedOrdemValue[existingOrderIndex] = { seqPagina: pagina.seqPagina, numOrdem: value };
                                      } else {
                                        updatedOrdemValue.push({ seqPagina: pagina.seqPagina, numOrdem: value });
                                      }

                                      return {
                                        ...prevValues,
                                        ordemBanner: { value: updatedOrdemValue, error: prevValues.ordemBanner.error },
                                      };
                                    });
                                  }}
                                  onBlur={(e) => validarOrdemAoSair(pagina.seqPagina, e.target.value, inputRef)}
                                  placeholder="Ordem"
                                  ref={inputRef}
                                />
                              </div>
                            </Flex>
                          )
                        })
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>

              </div>
              <div className="col-md-6 mb-4">
                <FormControl isRequired className="mb-4">
                  <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                  <CustomInput
                    placeholder='Digite um crédito ou autor da imagem'
                    value={formValues.creditoAutorImagem.value}
                    onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                  />
                </FormControl>
                <FormControl className='mb-4'>
                  <FormLabel mb="8px">Descrição de imagem</FormLabel>
                  <CustomInput
                    placeholder='Digite o texto alternativo da imagem'
                    value={formValues.altImagem.value}
                    onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                  />
                </FormControl>
                <FormControl className='mb-4'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>
                {/* <div className="row mt-2">
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        mt={3.5}
                        onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {formValues.exigeAprovacao.value === 1 && (
                    <div className="col-md-6 mb-4">
                      <FormControl isRequired>
                        <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                        <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                          <Stack spacing={5}>
                            {aprovadores.length > 0 ? (
                              aprovadores.map((aprovador: any) => (
                                <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                  <Radio
                                    value={aprovador.seqUsuario.toString()}
                                    isChecked={selectedUser === aprovador.seqUsuario}
                                    onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                                  >
                                    {aprovador.dscNome}
                                  </Radio>
                                </Flex>
                              ))
                            ) : (
                              <p>Não há lista de aprovadores disponíveis.</p>
                            )}
                          </Stack>
                        </div>
                      </FormControl>
                    </div>
                  )}
                </div> */}
              </div>
            </div>

            <Flex hidden={isAtivo == 0} mt="35px" justifyContent="end">
              <Button
                m="6px"
                onClick={() => navigate(-1)}
              >
                Desistir
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando Banner..."
              >
                {getCodSituacaoPubli == 6
                ? 'Reenviar para Aprovação'
                : 'Editar Banner'}      
              </Button>
              <Button
                onClick={() => inativarPublicacao()}
                m="6px"
                color="white"
                bgColor="red.500"
                _hover={{ bg: "red.600" }}
              >
                Inativar Publicação Imediatamente
              </Button>
            </Flex>
            {isAtivo == 0 && (
              <Flex mt="35px" justifyContent="end">
                <Button
                  color="#FFF"
                  bgColor="#1665D8"
                  m="6px"
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
              </Flex>
            )}
          </form>
        </Box>
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default EditarBanner;
